import { useEffect, useState } from "react";
import "./User.css";
import API from "../../services/api";
import { Button } from "primereact/button";

const UserModal = ({
  modalRef,
  form,
  handleChange,
  handleSubmit,
  editId,
  setEditId,
  setForm,
  validated,
  submitLoading,
  setValidated,
  allUsers,
}) => {
  const [moList, setMoList] = useState([]);
  const [tlsList, setTlsList] = useState([]);

  useEffect(() => {
    if (!allUsers || allUsers.length === 0) return;

    setMoList(allUsers.filter((u) => u.role === "mo"));
    setTlsList(allUsers.filter((u) => u.role === "tls"));
  }, [allUsers]);

  // ==== REAKSI SAAT ROLE BERUBAH ====
  useEffect(() => {
    const role = form.role;

    if (!role) return;

    switch (role) {
      case "mo":
        // mo_id & tls_id dikosongkan
        setForm((prev) => ({
          ...prev,
          mo_id: null,
          tls_id: null,
        }));
        break;

      case "tls":
        // TLS wajib punya MO, tapi tidak punya TLS
        setForm((prev) => ({
          ...prev,
          tls_id: null,
        }));
        break;

      case "sales":
        // Sales butuh mo_id & tls_id -> dihandle di form (required)
        break;

      case "super-user":
      case "cs-online":
        setForm((prev) => ({
          ...prev,
          mo_id: null,
          tls_id: null,
        }));
        break;
    }
  }, [form.role, setForm]);

  // ==== REAKSI SAAT MO DIGANTI (KHUSUS SALES: TLS DI-RESET) ====
  // useEffect(() => {
  //   if (form.role === "sales") {
  //     // kalau MO diganti, reset TLS
  //     setForm((prev) => ({
  //       ...prev,
  //       tls_id: "",
  //     }));
  //   }
  // }, [form.mo_id, form.role, setForm]);

  // TLS difilter berdasarkan MO yang dipilih
  const filteredTlsForSelectedMo =
    form.role === "sales" && form.mo_id
      ? tlsList.filter((tls) => String(tls.mo_id) === String(form.mo_id))
      : tlsList;

  return (
    <form
      noValidate
      className={validated ? "was-validated" : ""}
      onSubmit={handleSubmit}
    >
      <div
        className="modal fade"
        id="leadModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modalUser"
        ref={modalRef}
      >
        <div className="modal-dialog modal-user">
          <div className="modal-content modern-card">
            <div className="modal-header modern-header">
              <h5 className="modal-title fw-semibold" id="modalUser">
                {editId ? "Edit User" : "Tambah User"}
              </h5>
              <button
                type="button"
                className="btn-close shadow-none"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setValidated(false);
                }}
              ></button>
            </div>

            <div className="modal-body">
              {/* Input Nama */}
              <div className="mb-3">
                <label className="form-label modern-label">Nama</label>
                <input
                  type="text"
                  className="form-control modern-input"
                  name="name"
                  placeholder="Masukkan nama lengkap"
                  value={form.name || ""}
                  onChange={handleChange}
                  required
                />
                <div className="invalid-feedback">Nama wajib diisi.</div>
              </div>

              {/* Input Email */}
              <div className="mb-3">
                <label className="form-label modern-label">Email</label>
                <input
                  type="email"
                  className="form-control modern-input"
                  name="email"
                  placeholder="contoh@email.com"
                  value={form.email || ""}
                  onChange={handleChange}
                  required
                />
                <div className="invalid-feedback">Masukkan email valid.</div>
              </div>

              {/* Input Password */}
              <div className="mb-3">
                <label className="form-label modern-label">
                  {editId ? "Password (Opsional)" : "Password"}
                </label>
                <input
                  type="password"
                  className="form-control modern-input"
                  name="password"
                  placeholder={
                    editId
                      ? "Kosongkan jika tidak diganti"
                      : "Minimal 8 karakter"
                  }
                  value={form.password || ""}
                  onChange={handleChange}
                  required={!editId}
                  minLength={8}
                />
                <div className="invalid-feedback">
                  {editId
                    ? "Jika diisi, minimal 8 karakter."
                    : "Password minimal 8 karakter."}
                </div>
              </div>

              {/* Select Role */}
              <div className="mb-3">
                <label className="form-label modern-label">Pilih Role</label>
                <select
                  className="form-select modern-input"
                  name="role"
                  value={form.role || ""}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Pilih Role --</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                  <option value="operational">Operational</option>
                  <option value="mo">MO</option>
                  <option value="tls">TLS</option>
                  <option value="sales">Sales</option>
                  <option value="super-user">Super User</option>
                  <option value="cs-online">CS Online</option>
                </select>
                <div className="invalid-feedback">Role wajib dipilih.</div>
              </div>

              {/* DROPDOWN MO → TLS & SALES */}
              {(form.role === "tls" || form.role === "sales") && (
                <div className="mb-3">
                  <label className="form-label modern-label">Pilih MO</label>
                  <select
                    className="form-select modern-input"
                    name="mo_id"
                    value={form.mo_id || ""}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Pilih MO --</option>
                    {moList.map((mo) => (
                      <option key={mo.id} value={mo.id}>
                        {mo.name}
                      </option>
                    ))}
                  </select>
                  <div className="invalid-feedback">MO wajib dipilih.</div>
                </div>
              )}

              {/* DROPDOWN TLS → SALES */}
              {form.role === "sales" && (
                <div className="mb-3">
                  <label className="form-label modern-label">Pilih TLS</label>
                  <select
                    className="form-select modern-input"
                    name="tls_id"
                    value={form.tls_id || ""}
                    onChange={handleChange}
                    required
                    disabled={!form.mo_id}
                  >
                    <option value="">
                      {form.mo_id ? "-- Pilih TLS --" : "Pilih MO dulu"}
                    </option>
                    {filteredTlsForSelectedMo.map((tls) => (
                      <option key={tls.id} value={tls.id}>
                        {tls.name}
                      </option>
                    ))}
                  </select>
                  <div className="invalid-feedback">TLS wajib dipilih.</div>
                </div>
              )}
            </div>

            <div className="modal-footer border-top pt-3">
              <Button
                label="Close"
                icon="pi pi-times"
                outlined
                severity="secondary"
                type="button"
                className="rounded px-4"
                data-bs-dismiss="modal"
              />
              <Button
                label={
                  submitLoading ? "Memproses..." : editId ? "Update" : "Tambah"
                }
                icon={editId ? "pi pi-save" : "pi pi-plus"}
                severity="primary"
                loading={submitLoading}
                type="submit"
                className="rounded px-4"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UserModal;
